export default "__VITE_ASSET__DloA2Rir__"